import { useEffect, useState } from "react"

  const queries = {
    mobile: `(max-width: 799px)`,
    tablet: `(min-width: 800px) and (max-width: 1059px)`,
    desktop: `(min-width: 1060px)`,
  }

export const useBreakpoint = () => {
  const [breakpoint, setBreakpoint] = useState()
  const [letterbox, setLetterbox] = useState()


  const letterboxQuery = `(min-aspect-ratio: 17/9)`

  const getBreakpoint = () => {
    if (typeof window === "undefined") return false
    for (const [key, query] of Object.entries(queries)) {
      if (window.matchMedia(query).matches) return key
    }
    return false
  }

  const getLetterbox = () => {
    if (typeof window === "undefined") return false
    return window.matchMedia(letterboxQuery).matches
  }


  const handleChange = () => {
    setBreakpoint(getBreakpoint())
    setLetterbox(getLetterbox())
  }

  useEffect(() => {
    const matchMedias = [window.matchMedia(queries.mobile), window.matchMedia(queries.tablet), window.matchMedia(queries.desktop), window.matchMedia(letterboxQuery)]

    handleChange()

    matchMedias.forEach((mq) => {
      // Prefer modern API, fall back to deprecated only if unavailable
      if (mq.addEventListener) {
        mq.addEventListener("change", handleChange)
      } else {
        mq.addListener(handleChange)
      }
    })

    return () => {
      matchMedias.forEach((mq) => {
        if (mq.removeEventListener) {
          mq.removeEventListener("change", handleChange)
        } else {
          mq.removeListener(handleChange)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    value: breakpoint,
    letterbox: letterbox,
  }
}
